import { FundraisingReqRes } from 'src/app/dashboard/shared/holding/fundraising/fundraisings-tab/FundraisingReqRes.model';
import { GpFundReqRes } from 'src/app/dashboard/funds/GpFundReqRes.model';

export class FundAndFundraisingReqRes {
  constructor(public fund: GpFundReqRes, public fundraising: FundraisingReqRes, public notifyInvestors: boolean) {}
}
